import { getState } from "helpers";
import { selectProcessKasko } from "modules/app";

export const isProcessKasko = () => {
  return Boolean(selectProcessKasko(getState()));
};
